import { formatPlanningAmount } from '../../planning/planningAmount'

// Форматирование блока «План и факт» — общее для главной менеджера
// (ManagerPlanFactCard) и карточек менеджеров на главной помощника
// (AssistantManagerPlan, 29.09.2026).

const RU_MONTHS = [
  'январь',
  'февраль',
  'март',
  'апрель',
  'май',
  'июнь',
  'июль',
  'август',
  'сентябрь',
  'октябрь',
  'ноябрь',
  'декабрь',
]

/** «2026-09» → «сентябрь 2026». */
export function monthLabel(monthKey: string): string {
  const m = parseInt(monthKey.slice(5, 7), 10)
  return `${RU_MONTHS[m - 1] ?? monthKey} ${monthKey.slice(0, 4)}`
}

export function formatRub(n: number): string {
  return `${n.toLocaleString('ru-RU')} ₽`
}

// План и факт — с копейками, как их вносят в «Планировании» (17.09.2026).
export function formatPlanRub(n: number): string {
  return `${formatPlanningAmount(n, 'money')} ₽`
}

// Цвет прогресса по выполнению плана: <30% красный, 30-70% жёлтый, 70%+ зелёный.
export function progressColor(ratio: number): string {
  if (ratio < 0.3) return 'bg-red-500'
  if (ratio < 0.7) return 'bg-amber-500'
  return 'bg-emerald-500'
}

export function percentText(plan: number, fact: number): string {
  if (plan <= 0) return '—'
  return `${Math.round((fact / plan) * 1000) / 10}%`
}
